import React, { useCallback, useRef, useState, useEffect, Component } from "react";
import PropTypes from "prop-types";
import styles from "./PassportUserInputView.module.css";

import { AddButton } from "@cpnw/ui";
import FormDatePicker from "../FormDatePicker";
import PassportDownloadItem from "../PassportDownloadItem";
import DashboardPassportFileEditorItem from "../DashboardPassportFileEditorItem";
import DashboardRadio from "../DashboardRadio";
import PassportMessageForm from "../PassportMessageForm";
import PassportReviewItem from "../PassportReviewItem";

import { Button, InputBox, Loading, SelectBox, CheckboxItem, Modal } from "@cpnw/ui";
import { RequirementContainer } from "hooks/useRequirement";
import { parse, addYears, format, isAfter } from "date-fns";
import QuestionToggle from "components/QuestionToggle";
import classNames from "classnames";
import { formatUTCMidnightToSameDay } from "utils/helpers";
import ImmunizationTBView from "components/RequirementViews/ImmunizationTBView";
import ImmunizationHepBView from "components/RequirementViews/ImmunizationHepBView";
import ImmunizationMMRView from "components/RequirementViews/ImmunizationMMRView";
import ImmunizationVaricellaView from "components/RequirementViews/ImmunizationVaricellaView";
import ImmunizationTdapView from "components/RequirementViews/ImmunizationTdapView";
import ImmunizationCovidView from "components/RequirementViews/ImmunizationCovidView";
import ImmunizationRespiratorView from "components/RequirementViews/ScreenRespiratorView";
import ImmunizationInsuranceView from "components/RequirementViews/InsuranceView";
import InsuranceView from "components/RequirementViews/InsuranceView";
import ScreenRespiratorView from "components/RequirementViews/ScreenRespiratorView";
import { Categories, ContactTypes, DATE_FORMAT_PATTERN } from "pages/enums";
import { SubmissionTypes } from "components/RequirementViews/InsuranceView/InsuranceView";
import { AccountContainer } from "hooks/useAccount";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import CheckrBackgroundCheckView from "components/RequirementViews/CheckrBackgroundCheckView";
import ImmunizationMMRViewNew from "components/RequirementViews/ImmunizationMMRViewNew";
import ImmunizationHepBViewNew from "components/RequirementViews/ImmunizationHepBViewNew";
import ImmunizationTdapViewNew from "components/RequirementViews/ImmunizationTdapViewNew";
import ImmunizationVaricellaViewNew from "components/RequirementViews/ImmunizationVaricellaViewNew";
import ImmunizationCovidViewNew from "components/RequirementViews/ImmunizationCovidViewNew";
import ImmunizationInfluenzaViewNew from "components/RequirementViews/ImmunizationInfluenzaViewNew";
import CriminalHistoryDisclosureView from "components/RequirementViews/CriminalHistoryDisclosureView";
import { useSubmissionReportCompletedOn as useSubmissionReportCompletedOnPermission } from "hooks/useSubmissionReportCompletedOn";

const states = [
  "AL",
  "AK",
  "AS",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FM",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MH",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "MP",
  "OH",
  "OK",
  "OR",
  "PW",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VI",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

export default function PassportUserInputView({ requirement, onSaveComplete }) {
  const { userRoles } = AccountContainer.useContainer();

  console.log('requirement', requirement)

  const isELearning = requirement?.type?.Id === Categories.ELEARNING;
  const isTBTemplate = requirement.subCategory?.Id === 1; // TB
  const isHepBTemplate = requirement.subCategory?.Id === 2; // HepB
  const isMMRMMRVTemplate = requirement.subCategory?.Id === 3; // MMR/MMRV
  const isVaricellaTemplate = requirement.subCategory?.Id === 4; // Varicella
  const isTdapTemplate = requirement.subCategory?.Id === 5; // Tdap
  const isCovid19Template = requirement.subCategory?.Id === 6; // Covid-19
  const isRespiratorTemplate = requirement.subCategory?.Id === 7; // Respirator
  const isHepBNewTemplate = requirement.subCategory?.Id === 8; // HepB(new)
  const isMMRMMRVNewTemplate = requirement.subCategory?.Id === 9; // MMR/MMRV(new)
  const isVaricellaNewTemplate = requirement.subCategory?.Id === 10; // Varicella(new)
  const isTdapNewTemplate = requirement.subCategory?.Id === 11; // Tdap(new)
  const isInfluenzaNewTemplate = requirement.subCategory?.Id === 12; // Influenza
  const isCriminalHistoryDisclosureTemplate = requirement.subCategory?.Id === 14; // Criminal History Disclosure
  const isBLSNewTemplate = requirement.subCategory?.Id === 15; // BLS
  const isCovid19NewTemplate = requirement.subCategory?.Id === 16; // Covid-19(New)
  const isSiteOrientation = requirement.type?.Id === Categories.SITE_ORIENTATIONS;

  const insuranceViewRef = useRef();
  const tdapViewRef = useRef();
  const elementRef = useRef(null);
  const immunizationMMRViewNewRef = useRef();
  const immunizationHepBViewNewRef = useRef();
  const immunizationVaricellaNewRef = useRef();
  const immunizationTdapNewRef = useRef();
  const immunizationCovid19NewRef = useRef();
  const immunizationInfluenzaNewRef = useRef();
  const criminalHistoryDisclosureRef = useRef();
  const licenseFileRef = useRef(null);
  const fileRef = useRef(null);
  const licenseIndexForFilesRef = useRef(null);

  // Field DateOfIssue
  const [dateOfIssue, setDateOfIssue] = useState(
    requirement.submission.DateOfIssue ? formatUTCMidnightToSameDay(
      requirement.submission.DateOfIssue, DATE_FORMAT_PATTERN) : "")
  const [dateOfIssueChanged, setDateOfIssueChanged] = useState(false);

  // Field DateOfSignature
  const [dateOfSignature, setDateOfSignature] = useState(
    requirement.submission.DateOfSignature
      ? formatUTCMidnightToSameDay(requirement.submission.DateOfSignature, DATE_FORMAT_PATTERN) : ""
  );
  const [dateOfSignatureChanged, setDateOfSignatureChanged] = useState(false);

  // Field RequirementExpirationDate
  const [requirementExpirationDate, setRequirementExpirationDate] = useState("");
  const [requirementExpirationDateChanged, setRequirementExpirationDateChanged] = useState(true);

  const [declination, setDeclination] = useState(requirement.submission.Declination || null);

  const [viewResult, setViewResult] = useState(
    requirement.submission?.JSONContent
      ? JSON.parse(requirement.submission?.JSONContent)
      : {
        reportCompletedOn: null,
        type: "",
        date1: "",
        date2: "",
        manufacturer: "",
        test1: {},
        test2: {},
        serie1: {},
        serie2: {},
      }
  );

  const { visible: visibleSubmissionReportCompletedOn, editable: editableSubmissionReportCompletedOn } = useSubmissionReportCompletedOnPermission({
    requirementTypeId: requirement?.type?.Id,
    userRoles,
  });

  function hasAtLeastOneImmunizationDate(view) {
    const list = Array.isArray(view?.vaccineDates) ? view.vaccineDates : [];
    const vals = list.map(x => typeof x === "string" ? x :
      (x?.immunizationDate || "")
    ).filter(Boolean);
    return vals.some(s => /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s.trim()) || /^\d{4}-\d{2}-\d{2}$/.test(s.trim()));
  }

  /**
   * Compute Influenza expiry ("YYYY-09-30") from viewResult + declination.
   * - Declination => null
   * - Accepts dates in MM/DD/YYYY or YYYY-MM-DD
   * - Uses newest immunization date from:
   *     - source.vaccineDates[].immunizationDate
   *     - source.immunizationDate, source.date1, source.date2 (if present)
   */
  // Fixed-season influenza expiry from a view payload.
  // Returns "09/30/YYYY" or null (if declination), or throws if no valid date.

  // ---- Example usage ----
  /*
  const view = {
    vaccineDates: [
      { immunizationDate: "1/15/2025" },
      { immunizationDate: "09/20/2025" }, // newest → expiry 09/30/2026
      "10/18/2027", // even newer → expiry 09/30/2028
    ]
  };*/
  function getInfluenzaExpiration(viewResult, declination) {
    // --- Declination bypass ---
    if (declination) {
      return null;
    }

    // --- Gather candidate dates ---
    const pool = [];
    if (Array.isArray(viewResult && viewResult.vaccineDates)) {
      for (const item of viewResult.vaccineDates) {
        if (!item) continue;
        if (typeof item === "string" || item instanceof Date) {
          pool.push(item);
        } else if (item.immunizationDate) {
          pool.push(item.immunizationDate);
        }
      }
    }

    // --- Parse helpers ---
    const reIso = /^\d{4}-\d{2}-\d{2}$/;          // 2025-09-20
    const reUsFixed = /^\d{2}\/\d{2}\/\d{4}$/;    // 09/20/2025
    const reUsLoose = /^\d{1,2}\/\d{1,2}\/\d{4}$/; // 9/2/2025, 10/18/2027

    function toUtcMs(input) {
      if (input instanceof Date) {
        // Normalize to UTC midnight
        return Date.UTC(
          input.getUTCFullYear(),
          input.getUTCMonth(),
          input.getUTCDate()
        );
      }
      if (typeof input !== "string") return NaN;
      const str = input.trim();

      if (reIso.test(str)) {
        const [Y, M, D] = str.split("-").map(Number);
        return Date.UTC(Y, M - 1, D);
      }

      if (reUsFixed.test(str) || reUsLoose.test(str)) {
        const [mStr, dStr, yStr] = str.split("/");
        const MM = Number(mStr), DD = Number(dStr), YYYY = Number(yStr);
        if (!Number.isInteger(MM) || !Number.isInteger(DD) || !Number.isInteger(YYYY)) return NaN;
        return Date.UTC(YYYY, MM - 1, DD);
      }

      const t = new Date(str).getTime();
      return Number.isNaN(t) ? NaN : t;
    }

    // --- Pick newest date ---
    let newest = NaN;
    for (const s of pool) {
      const ms = toUtcMs(s);
      if (!Number.isNaN(ms)) newest = Number.isNaN(newest) ? ms : Math.max(newest, ms);
    }
    if (Number.isNaN(newest)) {
      throw new Error("Immunization Date is required");
    }

    // --- Fixed-season expiry ---
    // Season = Aug 1 (Y) → Sep 30 (Y+1)
    // Immunization Aug–Dec → expire Sep 30 of (Y+1)
    // Immunization Jan–Jul → expire Sep 30 of Y
    const d = new Date(newest);
    const y = d.getUTCFullYear();
    const m = d.getUTCMonth() + 1; // 1..12
    const expiryYear = m >= 8 ? y + 1 : y;

    // Always return as MM/DD/YYYY
    return `09/30/${expiryYear}`;
  }

  const getOct1CurrentYear = () => {
    const year = new Date().getFullYear();
    return format(new Date(year, 9, 1), DATE_FORMAT_PATTERN);
  };

  const getCurrentDate = () => {
    return format(new Date(), DATE_FORMAT_PATTERN);
  };

  function calculateBLSExpiration(baseDate) {
    if (!baseDate) return null;

    const parsed = new Date(baseDate);
    if (isNaN(parsed.getTime())) return null;

    // Add 2 years, then set to the last day of that month
    const year = parsed.getFullYear() + 2;
    const month = parsed.getMonth(); // 0 = Jan

    // Create a date for "day 0" of the next month → last day of target month
    const endOfMonth = new Date(year, month + 1, 0);

    // Normalize time to noon to avoid DST edge cases shifting the date
    endOfMonth.setHours(12, 0, 0, 0);

    return format(endOfMonth, DATE_FORMAT_PATTERN);
  }

  function calculateCriminalHistoryDisclosureExpiration(baseDate) {
    if (!baseDate) return null;

    const date = new Date(baseDate);
    if (isNaN(date.getTime())) return null;

    date.setFullYear(date.getFullYear() + 1);

    return format(date, DATE_FORMAT_PATTERN);
  }

  const calculateTdapNewExpiration = ({ fieldADate, fieldBDate, isDeclined, saveDate }) => {
    const parseDate = (d) => d ? new Date(d) : null;

    const dateA = parseDate(fieldADate);
    const dateB = parseDate(fieldBDate);
    const saveDt = new Date(saveDate);

    // If declined, return 1 year from saveDate
    if (isDeclined) {
      const oneYearFromSave = new Date(saveDt);
      oneYearFromSave.setFullYear(saveDt.getFullYear() + 1);
      return formatUTCMidnightToSameDay(oneYearFromSave.toISOString().split('T')[0]);
    }

    // Neither A nor B entered
    if (!dateA && !dateB) {
      throw new Error("You must enter a date in either Field A or Field B, or select Declination.");
    }

    // Use the newest of A and B
    const latestDate = !dateA ? dateB
      : !dateB ? dateA
        : (dateA > dateB ? dateA : dateB);

    const expirationDate = new Date(latestDate);
    expirationDate.setFullYear(expirationDate.getFullYear() + 10);

    return format(expirationDate, DATE_FORMAT_PATTERN);
  };

  // Auto-calc Influenza expiration per fixed-season rule, using NEWEST date.
  // Declination → no date required & no expiry set.
  useEffect(() => {
    if (!isInfluenzaNewTemplate) return;

    try {
      const exp = getInfluenzaExpiration(viewResult, declination);
      // exp is either "YYYY-09-30" or null (declined)
      setRequirementExpirationDate(exp || null);
      setRequirementExpirationDateChanged(true);
      console.log("Influenza expiry is:", exp);
    } catch (err) {
      // Missing/invalid dates when not declined → leave empty so validator can warn.
      console.warn("Influenza expiry not set:", err.message);
      setRequirementExpirationDate(null);
    }
  }, [isInfluenzaNewTemplate, viewResult, declination]);

  useEffect(() => {
    const safeFormat = (date) =>
      date ? formatUTCMidnightToSameDay(date, DATE_FORMAT_PATTERN) : "";

    let newExpiration = "";

    if (isInfluenzaNewTemplate) {
      newExpiration = requirement.expiresOn
        ? safeFormat(requirement.expiresOn)
        : requirement.annualDate || getOct1CurrentYear();
    } else if (isCriminalHistoryDisclosureTemplate) {
      newExpiration = requirement.expiresOn
        ? safeFormat(requirement.expiresOn)
        : requirement.annualDate || calculateCriminalHistoryDisclosureExpiration(getCurrentDate());
    } else if (isBLSNewTemplate) {
      newExpiration = requirement.expiresOn
        ? safeFormat(requirement.expiresOn)
        : requirement.annualDate || calculateBLSExpiration(getCurrentDate());
    } else {
      newExpiration = safeFormat(requirement.expiresOn);
    }

    setRequirementExpirationDate(newExpiration);
  }, [
    requirement,
    requirement.expiresOn,
    requirement.annualDate,
    isInfluenzaNewTemplate,
    isCriminalHistoryDisclosureTemplate,
    isBLSNewTemplate,
  ]);

  useEffect(() => {
    if (!isBLSNewTemplate) return;
    if (!dateOfIssue) return;

    try {
      const exp = calculateBLSExpiration(dateOfIssue);
      setRequirementExpirationDate(exp);
      setRequirementExpirationDateChanged(true);
    } catch (err) {
      console.warn("Expiration not set:", err.message);
      setRequirementExpirationDate(null);
    }
  }, [dateOfIssue, isBLSNewTemplate]);


  useEffect(() => {
    const disclosureSignatureDates = viewResult.disclosureSignatureDates || [];
    if (!isCriminalHistoryDisclosureTemplate) return;
    if (disclosureSignatureDates.length == 0) return;

    try {
      const latestDate = disclosureSignatureDates.reduce((latest, current) => {
        const currentDate = new Date(current.dateOfDisclosureSignature);
        return isAfter(currentDate, latest) ? currentDate : latest;
      }, new Date(0)); // Start with the earliest date

      const exp = calculateCriminalHistoryDisclosureExpiration(latestDate);
      setRequirementExpirationDate(exp);
      setRequirementExpirationDateChanged(true);
    } catch (err) {
      console.warn("Expiration not set:", err.message);
      setRequirementExpirationDate(null);
    }
  }, [viewResult, isCriminalHistoryDisclosureTemplate]);

  useEffect(() => {
    if (!isTdapNewTemplate) return;

    const content = JSON.parse(requirement.submission?.JSONContent || "{}");

    if (!content.date1 && !content.date2) return;
    try {
      const exp = calculateTdapNewExpiration({
        fieldADate: content.date1,
        fieldBDate: content.date2,
        isDeclined: null,
        saveDate: format(new Date(), DATE_FORMAT_PATTERN),
      });

      setRequirementExpirationDate(exp);
      setRequirementExpirationDateChanged(true);
    } catch (err) {
      console.warn("Expiration not set:", err.message);
      setRequirementExpirationDate(null); // optional fallback
    }
  }, [viewResult, isTdapNewTemplate]);










  const [dataLoading, setDataLoading] = useState(false);
  const [size, setSize] = useState({ width: 0, height: 0 });

  const { useRequirementMessages, postRequirementMessage, submitRequirement,
    // sendHealthReasonNotification
  } = RequirementContainer.useContainer();

  const { data: messagesData, refetch: refetchMessages } =
    useRequirementMessages(requirement.contactRequirementId);
  const messages = (messagesData || requirement.messages || []).map((a) => {
    const allMessages = messagesData || requirement.messages || [];

    const repliedToMessage =
      a.RepliedToMessageId != null
        ? allMessages.find((m) => m.Id === a.RepliedToMessageId)
        : null;

    return {
      messageId: a.Id,
      fromContactId: a.FromContactId,
      currentContactId: a.CurrentContactId,
      name: a.FromContact,
      date: format(a.RepliedOn, "Pp"),
      message: a.Message,
      repliedToMessage: repliedToMessage
        ? {
          name: repliedToMessage.FromContact,
          date: format(repliedToMessage.RepliedOn, "Pp"),
          message: repliedToMessage.Message,
        }
        : null,
    };
  });

  const roles = userRoles.map((a) => a.toUpperCase());
  const isStudent = roles.includes("STUDENT") || roles.includes("FACULTY");
  // Should we show the reset confirmation?
  const needsResetConfirm =
    isStudent &&
    !isELearning &&
    (requirement?.status === "Approved" || requirement?.status === "Conditionally Approved");

  // Confirmation modal state
  const [resetConfirmOpen, setResetConfirmOpen] = useState(false);

  const canDeleteFile = () => {
    if (roles.includes("STUDENT") || roles.includes("FACULTY")) {
      return false;
    }
    return true;
  }

  const [disabled, setDisabled] = useState(requirement.type?.Id == Categories.CHECKR_BACKGROUND_CHECK || requirement.type?.Id == Categories.CPNW_WATCH);
  console.log("DISABLE - role student", disabled, roles)

  const handleDeclinationChange = (value) => {
    setDeclination(value);
  };

  const handleOnSend = useCallback(
    (text, repliedToMessage, selectedRecipients) => {
      console.log("requirement", requirement);
      postRequirementMessage({
        contactRequirementId: requirement.contactRequirementId,
        message: text,
        repliedToMessageId: repliedToMessage ? repliedToMessage.messageId : null,
        groupOfRecipients: selectedRecipients
      }).then(() => {
        refetchMessages();
      });
    },
    [requirement]
  );

  const [isWaived, setIsWaived] = useState(requirement.isWaived);






  const [declinationDate, setDeclinationDate] = useState(declination ? format(new Date(), DATE_FORMAT_PATTERN) : "")








  const [immunizationDate, setImmunizationDate] = useState(
    requirement.submission.ImmunizationDate
      ? formatUTCMidnightToSameDay(
        requirement.submission.ImmunizationDate,
        DATE_FORMAT_PATTERN
      )
      : null
  );
  const [expirationDate, setExpirationDate] = useState(
    requirement.submission.ExpiresOn
      ? formatUTCMidnightToSameDay(
        requirement.submission.ExpiresOn,
        DATE_FORMAT_PATTERN
      )
      : null
  );
  const [location, setLocation] = useState(
    requirement.submission.Location || ""
  );
  const [files, setFiles] = useState(requirement.submission.files || []);
  const [newFiles, setNewFiles] = useState([]);

  const [hasLicenses, setHasLicenses] = useState(
    requirement.hasLicenses ? "yes" : "no"
  );
  const [licenses, setLicenses] = useState(
    requirement.hasLicenses
      ? (requirement.submissions || []).map((license) => {
        return {
          id: license.Id,
          licenseType: license.LicenseType,
          licenseNumber: license.LicenseNumber,
          issuedBy: license.IssuedBy,
          issuedOn: license.IssuedOn
            ? formatUTCMidnightToSameDay(license.IssuedOn)
            : "",
          expiresOn: license.ExpiresOn
            ? formatUTCMidnightToSameDay(license.ExpiresOn)
            : "",
          files: (license.Files || []).map((a) => ({
            id: a.Id,
            name: a.Name,
            url: a.Url,
          })),
          newFiles: [],
        };
      })
      : []
  );

  console.log("licenses", licenses);

  const handleChange = useCallback(
    (license, value, update) => {
      let name = update;

      const li = licenses.find((a) => a.id == license.id);
      li[name] = value;
      setLicenses([...licenses]);
    },
    [licenses]
  );

  const onAddMoreLicense = useCallback(() => {
    licenses.push({
      id: Math.random(),
      newFiles: [],
    });
    setLicenses([...licenses]);
  }, [licenses]);



  const onUploadLicenses = (index) => {
    licenseIndexForFilesRef.current = index;
    licenseFileRef.current.click();
  };

  const onLicenseFileChange = (e) => {
    const index = licenseIndexForFilesRef.current;
    const license = licenses[index];
    license.newFiles = e.target.files;
    setLicenses([...licenses]);
  };

  const onFileChange = (e) => {
    const addFiles = e.target.files;
    for (const f of addFiles) {
      if (f.name.length >= 255) {
        alert("Please use file name with less than 255 characters.");
        return
      }
      f.id = Math.random();
    }
    setNewFiles((newFiles) => [...newFiles, ...addFiles]);
  };

  function removeFileFromFileList(fileList, indexToRemove) {
    const dt = new DataTransfer();

    for (let i = 0; i < fileList.length; i++) {
      if (i !== indexToRemove) {
        dt.items.add(fileList[i]);
      }
    }

    return dt.files;
  }



  const onSetHasLicenses = useCallback(
    (value) => {
      if (value == "yes" && licenses.length == 0) {
        licenses.push({
          id: Math.random(),
          newFiles: [],
        });
        setLicenses([...licenses]);
      }

      setHasLicenses(value);
    },
    [hasLicenses, licenses]
  );



  const [validationErrors, setValidationErrors] = useState({});
  const handleValidation = (errors) => {
    setValidationErrors((prevErrors) => ({ ...prevErrors, ...errors }));
  };


  const [errors, setErrors] = useState([]);
  const validator = () => {
    let newErrors = [];
    if (Categories.CERTS == requirement.type.Id) {
      const noFiles = (files?.length || 0) + (newFiles?.length || 0) === 0;

      if (isBLSNewTemplate) {
        // Must have Date of Issue OR a file
        if ((!dateOfIssue || dateOfIssue.trim() === "") && noFiles) {
          newErrors.push("Please provide Date of Issue or upload a document.");
        }
      } else {
        // Non‑BLS: Expiration Date OR a file
        if ((!expirationDate || expirationDate.trim() === "") && noFiles) {
          newErrors.push("Please provide an Expiration Date or upload a document.");
        }
      }
    } else if (Categories.LICENSES == requirement.type.Id) {

    } else if (Categories.ELEARNING == requirement.type.Id) {

    } else if (Categories.FORMS == requirement.type.Id) {
      if (isCriminalHistoryDisclosureTemplate) {
        criminalHistoryDisclosureRef.current?.validator();
        if ((viewResult.disclosureSignatureDates || []).length === 0) {
          newErrors.push("Please provide at least one Disclosure Signature Date.");
        }
      }
      if (files.concat(newFiles).length === 0) {
        newErrors.push("Please upload a document.");
      }
    } else if (Categories.IMMUNIZATION == requirement.type.Id) {
      if (!requirement.subCategory) {
        // if (!declination && files.concat(newFiles).length === 0) {
        //   newErrors.push("Please select a declination option or upload a document.");
        // }
      } else if (requirement.subCategory && requirement.subCategory.Name == "Tdap") {
        const tdapViewErrors = tdapViewRef.current ? tdapViewRef.current.validate() : null;

        if (tdapViewErrors && Object.keys(tdapViewErrors).length > 0) {
          setValidationErrors(tdapViewErrors);
          newErrors.push("");
        } else if (files.concat(newFiles).length === 0 && requirement.createdByTypeContact !== ContactTypes.CPNW_ADMIN) {
          // #1634677986 - Not required to upload a document
          // newErrors.push("Please upload a document.");
        } //#1568602332: CPNW QA BUGS

      } else if (isTdapNewTemplate) {
        const tdapViewNewErrors = immunizationTdapNewRef.current ? immunizationTdapNewRef.current.validate() : null;

        if (tdapViewNewErrors && Object.keys(tdapViewNewErrors).length > 0) {
          setValidationErrors(tdapViewNewErrors);
          newErrors.push("");
        } else if (files.concat(newFiles).length === 0 && requirement.createdByTypeContact !== ContactTypes.CPNW_ADMIN) {
          // #1634677986 - Not required to upload a document
          // newErrors.push("Please upload a document.");
        } //#1568602332: CPNW QA BUGS

      } else if (isInfluenzaNewTemplate) {
        immunizationInfluenzaNewRef.current.validator();
        if ((!viewResult.vaccineDates || viewResult.vaccineDates.length === 0 || !hasAtLeastOneImmunizationDate(viewResult)) && !declination) {
          newErrors.push("Please enter vaccinate date(s).");
        } else if (declination) {// If declined, skip date checks entirely
          // OK: no date required, no expiry
        } else {
          // Not declined → require an immunization date (any of the supported fields)
          const exp = (() => {
            try { return getInfluenzaExpiration(viewResult, declination); }
            catch { return null; }
          })();
          if (!exp) newErrors.push("Please enter vaccinate date(s).");
        }
      } else if (isMMRMMRVNewTemplate) {
        immunizationMMRViewNewRef.current.validator();
        if (!viewResult.type && !viewResult.manufacturer && !viewResult.date1 && !viewResult.date2 && !declination) {
          newErrors.push("Please select a submission option or a declination option.");
        }
      } else if (isHepBNewTemplate) {
        const errors = immunizationHepBViewNewRef.current.validator();
        if (!viewResult.type && !viewResult.manufacturer && !viewResult.date1 && !viewResult.date2 && !declination) {
          newErrors.push("Please select a submission option or a declination option.");
        }
        if (errors) {
          // Collect field-level errors (they will be displayed inside the form, not below)
          Object.values(errors).forEach((msg) => newErrors.push(''));
        }

      } else if (isVaricellaNewTemplate) {
        immunizationVaricellaNewRef.current.validator();
        if (!viewResult.type && !viewResult.manufacturer && !viewResult.date1 && !viewResult.date2 && !declination) {
          newErrors.push("Please select a submission option or a declination option.");
        }
      } else if (isCovid19NewTemplate) {
        immunizationCovid19NewRef.current.validator();
      }

      else {
        if (!viewResult.type && !viewResult.manufacturer && !viewResult.date1 && !viewResult.date2 && !declination) {
          newErrors.push("Please select a submission option or a declination option.");
        }
      }



    } else if (Categories.INSURANCE == requirement.type.Id) {
      const insuranceViewErrors = insuranceViewRef.current ? insuranceViewRef.current.validate() : null;

      if (insuranceViewErrors && Object.keys(insuranceViewErrors).length > 0) {
        setValidationErrors(insuranceViewErrors);
        newErrors.push("");
      } else if (viewResult.type == SubmissionTypes.B && files.concat(newFiles).length === 0) {
        newErrors.push("Please upload a document.");
      }
    } else if (Categories.SCREENS_CHECKS == requirement.type.Id) {
      if (!declination && files.concat(newFiles).length === 0 && viewResult.date1 == '') {
        newErrors.push("Please select a submission option or a declination option or upload a document");
      }
    } else if (Categories.SITE_ORIENTATIONS == requirement.type.Id) {

    }

    setErrors(newErrors);
    // If all checks pass, allow continuous
    return newErrors.length > 0 ? false : true;
  }

  const [autoApprovalAlert, setAutoApprovalAlert] = useState(false);
  const [autoApproval, setAutoApproval] = useState(requirement?.autoApproval);
  useEffect(() => {
    if (requirement.autoApproval) {
      setAutoApproval(true);
    } else {
      setAutoApproval(false);
    }
  }, [requirement])

  const onSave = async () => {
    // // set expiration date for TDAP
    // let exp = expirationDate;
    // if (requirement.subCategory) {
    //   if (requirement.subCategory.Name == "Tdap(new)") {
    //     //Student: 10 years
    //     if (roles.includes("STUDENT")) {
    //       const date1Str = viewResult?.date1;
    //       const date2Str = viewResult?.date2;

    //       const parsedDate1 = parse(date1Str, DATE_FORMAT_PATTERN, new Date());
    //       const parsedDate2 = parse(date2Str, DATE_FORMAT_PATTERN, new Date());

    //       // Get the newer date
    //       const newerDate = isAfter(parsedDate1, parsedDate2) ? parsedDate1 : parsedDate2;

    //       // Add 10 years and format
    //       exp = format(addYears(newerDate, 10), DATE_FORMAT_PATTERN);
    //     }
    //   }
    // }
    // // set expirationDate for Influenza
    // if (requirement.subCategory.Name === "Influenza") {
    //   //Expiration date: 1 year
    //   exp = format(addYears(parse(immunizationDate, DATE_FORMAT_PATTERN, new Date()), 1), DATE_FORMAT_PATTERN);
    // }

    // //set expirationDate for BLS
    // else if (requirement.subCategory.Name === "BLS") {
    //   // Expiration: 2 years
    //   console.log("BLS on save")
    //   exp = format(addYears(parse(dateOfIssue, DATE_FORMAT_PATTERN, new Date()), 2), DATE_FORMAT_PATTERN)

    // }
    // else if (requirement.subCategory.Name === "Criminal History Disclosure") {
    //   // Expiration: 1 years
    //   exp = format(addYears(parse(dateOfDisclosure, DATE_FORMAT_PATTERN, new Date()), 1), DATE_FORMAT_PATTERN)

    // }

    if (validator()) {
      setDataLoading(true);
      try {

        // const viewNewFiles = Object.values(viewResult)
        //   .flatMap(section => Array.from(section?.newFiles || []));

        const doesHaveLicenses = hasLicenses == "yes";
        const dto = {
          contactRequirementId: requirement.contactRequirementId,
          submissionId: requirement.submission.Id,
          licenses: doesHaveLicenses
            ? licenses.map((license) => {
              return {
                ...license,
                newFiles: Array.from(license.newFiles).map((f) => f.name),
              };
            })
            : [],
          declination: declination,
          immunizationDate,
          location,
          hasLicenses: doesHaveLicenses,
          files,
          newFiles: newFiles.map((a) => a.name),
          viewResult: JSON.stringify(viewResult),
          isWaived,
          autoApproval: requirement.autoApproval,
          // ...(isHepBNewTemplate && {
          //   hepBNewFiles: viewNewFiles.map(f => f.name),
          // }),
          ...(isBLSNewTemplate && {
            dateOfIssue,
            requirementExpirationDate
          }),
          ...(isTdapNewTemplate && {
            requirementExpirationDate
          }),
          ...(isInfluenzaNewTemplate && {
            requirementExpirationDate
          }),
          ...(isCriminalHistoryDisclosureTemplate && {
            requirementExpirationDate
          }),
          ...(isSiteOrientation && requirement.autoApproval && requirement.frequency === "Annually" && {
            requirementExpirationDate: null
          }),
        };

        await submitRequirement(
          dto,
          [
            ...newFiles,
            ...(isHepBNewTemplate ? Object.values(viewResult)
              .flatMap(section => Array.from(section?.newFiles || []).filter(f => f instanceof File)) : []),
          ].concat(
            licenses.flatMap((license) => {
              return Array.from(license.newFiles);
            })
          )
        ).then(() => {
          if (onSaveComplete) {
            if (isHepBNewTemplate) {
              immunizationHepBViewNewRef.current.onSaveComplete();
            }
            onSaveComplete();
          }
        });

        console.log("UserInputView requirement", requirement);
        console.log("UserInputView OnSave dto", dto);
      } catch (error) {
        console.error("onSave failed:", error);
        try {
          const body = JSON.parse(error.message);
          setErrors(body.errors?.length > 0 ? body.errors : ["An error occurred while saving. Please try again."]);
        } catch {
          setErrors([error.message || "An error occurred while saving. Please try again."]);
        }
      } finally {
        // Set loading state to false, regardless of success or failure
        setDataLoading(false);
      }
    }
  };

  const handleHealthReasonNotify = async () => {
    // try {
    //   await sendHealthReasonNotification({
    //     contactRequirementId: requirement.contactRequirementId
    //   });

    //   console.log("Health Reason notifications sent successfully");
    // } catch (err) {
    //   console.error("Failed to send Health Reason notifications:", err);
    // }
  };

  // Centralized “next step” after the reset check passes
  const proceedAfterResetCheck = useCallback(() => {
    // keep validation gate consistent with current flow
    if (autoApproval && validator()) {
      setAutoApprovalAlert(true); // will show existing Auto Approval modal
    } else {
      onSave(); // existing save
    }
  }, [autoApproval, validator, onSave, setAutoApprovalAlert]);

  // Entry point when clicking SAVE
  const handleSaveClick = useCallback(() => {
    if (needsResetConfirm) {
      setResetConfirmOpen(true);
    } else {
      proceedAfterResetCheck();
    }
  }, [needsResetConfirm, proceedAfterResetCheck]);

  useEffect(() => {
    if (elementRef.current) {
      const { width, height } = elementRef.current.getBoundingClientRect();
      setSize({ width, height });
    }
  }, []);
  const handleClearSubmission = () => {
    const userConfirmed = window.confirm("Are you sure you want to clear any information that was entered?");
    if (userConfirmed) {
      setLocation('')
      setHasLicenses('no')
      setLicenses([])
      setImmunizationDate(null)
      delete viewResult.notAvailable
      setViewResult({
        reportCompletedOn: null,
        type: "",
        date1: "",
        date2: "",
        manufacturer: "",
        test1: {},
        test2: {},
        serie1: {},
        serie2: {},
      })
      // }


    }
  };

  // Handler for clear Declination button click
  const handleClearDeclination = () => {
    setDeclination('');
  }



  return (
    <>
      <div
        className={classNames(styles.container, styles.customContainer)}
        ref={elementRef}
      >
        {dataLoading && (
          <div
            className={styles.loadingContainer}
            style={{ height: size.height + "px" }}
          >
            <Loading />
          </div>
        )}
        <div className={classNames(styles.column1)}>
          <div className={styles.row}>
            <PassportReviewItem
              label="Requirement Name"
              description={requirement.requirementName}
            />
            <PassportReviewItem
              label="Abbr"
              description={requirement.abbreviation}
            />
            <PassportReviewItem
              label="Required By"
              description={requirement.requiredBy}
            />
            <PassportReviewItem
              label="Frequency"
              description={requirement.frequency}
            />
          </div>
          <div className={styles.instructions}>
            <PassportReviewItem
              label="Instructions"
              description={requirement.instructions}
            />
          </div>
          <div className={styles.row}>
            <div className={styles.column}>
              <p className={styles.paragraph}>Files/Forms</p>
              <div className={styles.fileSetup}>
                {requirement.requirementFiles.map((f) => {
                  return <PassportDownloadItem key={f.id} file={f} />;
                })}
              </div>
            </div>
          </div>
          <hr>{/* Horizontal Rule */}</hr>

          <div>
            <div>
              <h4>Submission:</h4>
            </div>
            {!disabled && (
              <div>
                {requirement.subCategory !== undefined ? (
                  <Button
                    className={styles.clear_button}
                    onClick={handleClearSubmission}
                    text="Clear Fields"
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </div>

          {/* {requirement.allowWaiver && (
            <div className={styles.column}>
              <CheckboxItem
                className={styles.checkbox}
                onClick={(isChecked) => setIsWaived(!!isChecked)}
                description={"Waive this requirement"}
                isChecked={isWaived}
              />
            </div>
          )} */}

          {!isWaived && (
            <div>
              {visibleSubmissionReportCompletedOn && (
                <CheckrBackgroundCheckView
                  data={viewResult}
                  onChange={(result) => {
                    setViewResult(result);
                    setErrors([]);
                  }}
                  disabled={!editableSubmissionReportCompletedOn}
                />
              )}
              {/* {Categories.IMMUNIZATION == requirement.type.Id &&
                !requirement.subCategory && ( // Old Influenza
                  <div
                    className={classNames(
                      styles.row,
                      styles.columnImmunizationDate
                    )}
                  >
                    <FormDatePicker
                      label="Immunization Date"
                      dateFormat={DATE_FORMAT_PATTERN}
                      dateString={immunizationDate}
                      setDate={setImmunizationDate}
                      disabled={disabled}
                    />
                    <div
                      className={classNames(
                        styles.column,
                        styles.columnLocation
                      )}
                    >
                      <InputBox
                        label="Location Received"
                        placeholder="Provider Name & Location"
                        value={location}
                        setValue={(e) => {
                          setLocation(e.target.value);
                        }}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                )} */}

              {/* {isInfluenzaTemplate && (
                <div
                  className={classNames(
                    styles.row,
                    styles.columnImmunizationDate
                  )}
                >
                  <FormDatePicker
                    label="Immunization Date"
                    dateFormat=DATE_FORMAT_PATTERN
                    dateString={immunizationDate}
                    setDate={setImmunizationDate}
                    disabled={disabled}
                  />
                  <div
                    className={classNames(
                      styles.column,
                      styles.columnLocation
                    )}
                  >
                    <InputBox
                      label="Location Received"
                      placeholder="Provider Name & Location"
                      value={location}
                      setValue={(e) => {
                        setLocation(e.target.value);
                      }}
                      disabled={disabled}
                    />
                  </div>
                </div>
              )} */}

              {isBLSNewTemplate && (
                <div className={classNames(styles.row)}>
                  <FormDatePicker
                    label="Date of Issue"
                    dateFormat={DATE_FORMAT_PATTERN}
                    dateString={dateOfIssue}
                    setDate={(value) => {
                      setDateOfIssue(value);
                      setDateOfIssueChanged(true);
                    }}
                    disabled={disabled}
                  />
                </div>
              )}
              {isCriminalHistoryDisclosureTemplate && (
                <CriminalHistoryDisclosureView
                  data={viewResult}
                  onChange={(result) => {
                    console.log("CriminalHistoryDisclosureView result", result);
                    setViewResult(result);
                    setErrors([]);
                  }}
                  disabled={disabled}
                  onValidate={handleValidation}
                  ref={criminalHistoryDisclosureRef}
                />
              )}
              {requirement.subCategory &&
                requirement.subCategory.Name == "TB" && (
                  <ImmunizationTBView
                    data={viewResult}
                    onChange={(result) => {
                      console.log("ImmunizationTBView result", result);
                      setViewResult(result);
                    }}
                    disabled={disabled}
                  />
                )}
              {requirement.subCategory &&
                requirement.subCategory.Name == "HepB" && (
                  <ImmunizationHepBView
                    data={viewResult}
                    onChange={(result) => {
                      console.log("ImmunizationHepBView result", result);
                      setViewResult(result);
                    }}
                    disabled={disabled}
                  />
                )}
              {isHepBNewTemplate && (
                <ImmunizationHepBViewNew
                  data={viewResult}
                  disabled={disabled}
                  roles={roles}
                  onNotify={handleHealthReasonNotify}
                  onChange={(result) => {
                    console.log("ImmunizationHepBViewNew result", result);
                    setViewResult(result);
                  }}
                  ref={immunizationHepBViewNewRef}
                />
              )}
              {requirement.subCategory &&
                requirement.subCategory.Name == "MMR/MMRV" && (
                  <ImmunizationMMRView
                    data={viewResult}
                    onChange={(result) => {
                      console.log("ImmunizationMMRView result", result);
                      setViewResult(result);
                    }}
                    disabled={disabled}
                  />
                )}
              {isMMRMMRVNewTemplate && (
                <ImmunizationMMRViewNew
                  data={viewResult}
                  onChange={(result) => {
                    console.log("ImmunizationMMRViewNew result", result);
                    setViewResult(result);
                  }}
                  ref={immunizationMMRViewNewRef}
                />
              )}
              {requirement.subCategory &&
                requirement.subCategory.Name == "Varicella" && (
                  <ImmunizationVaricellaView
                    data={viewResult}
                    onChange={(result) => {
                      console.log("ImmunizationVaricellaView result", result);
                      setViewResult(result);
                    }}
                    disabled={disabled}
                  />
                )}
              {isVaricellaNewTemplate && (
                <ImmunizationVaricellaViewNew
                  data={viewResult}
                  disabled={disabled}
                  onChange={(result) => {
                    console.log("ImmunizationVaricellaView result", result);
                    setViewResult(result);
                  }}
                  ref={immunizationVaricellaNewRef}
                />
              )}
              {requirement.subCategory &&
                requirement.subCategory.Name == "Tdap" && (
                  <ImmunizationTdapView
                    data={viewResult}
                    selectedDeclination={declination}
                    onChange={(result) => {
                      console.log("ImmunizationTdapView result", result);
                      setViewResult(result);
                    }}
                    disabled={disabled}
                    ref={tdapViewRef}
                    onValidate={handleValidation}
                    setDate={setImmunizationDate}
                  />
                )}
              {isTdapNewTemplate && (
                <ImmunizationTdapViewNew
                  data={viewResult}
                  selectedDeclination={declination}
                  disabled={disabled}
                  onChange={(result) => {
                    console.log("ImmunizationTdapView result", result);
                    setViewResult(result);
                  }}
                  onValidate={handleValidation}
                  ref={immunizationTdapNewRef}
                />
              )}
              {requirement.subCategory &&
                requirement.subCategory.Name == "Covid-19" && (
                  <ImmunizationCovidView
                    data={viewResult}
                    onChange={(result) => {
                      console.log("ImmunizationCovidView result", result);
                      setViewResult(result);
                    }}
                    disabled={disabled}
                  />
                )}
              {isCovid19NewTemplate && (
                <ImmunizationCovidViewNew
                  data={viewResult}
                  onChange={(result) => {
                    console.log("ImmunizationCovidView result", result);
                    setViewResult(result);
                  }}
                  disabled={disabled}
                  ref={immunizationCovid19NewRef}
                />
              )}
              {isInfluenzaNewTemplate && (
                <ImmunizationInfluenzaViewNew
                  data={viewResult}
                  onChange={(result) => {
                    console.log("ImmunizationInfluenzaViewNew result", result);
                    setViewResult(result);
                  }}
                  disabled={disabled}
                  onValidate={handleValidation}
                  ref={immunizationInfluenzaNewRef}
                />
              )}
              {requirement.subCategory &&
                requirement.subCategory.Name == "Respirator" && (
                  <ScreenRespiratorView
                    data={viewResult}
                    onChange={(result) => {
                      console.log("ImmunizationRespiratorView result", result);
                      setViewResult(result);
                    }}
                    disabled={disabled}
                  />
                )}
              {requirement.type.Name == "Insurance" && (
                <InsuranceView
                  data={viewResult}
                  onChange={(result) => {
                    console.log("InsuranceView result", result);
                    setViewResult(result);
                    setErrors([]);
                  }}
                  disabled={disabled}
                  ref={insuranceViewRef}
                  onValidate={handleValidation}
                />
              )}
              {(requirement.type.HasImmunizationDate ||
                requirement.type.HasLocation ||
                requirement.type.HasExpiration) && (
                  <div className={styles.row}>
                    {requirement.type.HasImmunizationDate && (!requirement.subCategory || requirement.subCategory.HasImmunizationDate) && (
                      <FormDatePicker
                        label="Immunization Date"
                        dateFormat={DATE_FORMAT_PATTERN}
                        dateString={immunizationDate}
                        setDate={setImmunizationDate}
                        disabled={disabled}
                      />
                    )}
                    {(requirement.type.HasExpiration) && (!requirement.subCategory || requirement.subCategory.HasExpiration) &&
                      requirement.subCategory && (
                        <FormDatePicker
                          label="Expiration Date"
                          dateFormat={DATE_FORMAT_PATTERN}
                          dateString={expirationDate}
                          setDate={setExpirationDate}
                          disabled={disabled}
                        />
                      )}

                    {requirement.type.HasLocation && (!requirement.subCategory || requirement.subCategory.HasLocation) && (
                      <div className={styles.column}>
                        <InputBox
                          label="Location Received"
                          placeholder="Provider Name & Location"
                          value={location}
                          setValue={(e) => {
                            setLocation(e.target.value);
                          }}
                          disabled={disabled}
                        />
                      </div>
                    )}
                  </div>
                )}
              {requirement.type.HasLicense ? (
                <>
                  <div className={styles.innerColumnContainer}>
                    <div className={styles.innerColumn}>
                      <span className={styles.textBold}>
                        Do you hold an active healthcare license?
                      </span>
                      <QuestionToggle
                        disabled={disabled}
                        value={hasLicenses}
                        onClick={(value) => onSetHasLicenses(value)}
                      />
                    </div>
                  </div>
                  <div>
                    {licenses.length > 0 && (
                      <div className={styles.licenseContainer}>
                        <div className={styles.innerColumnContainer}>
                          <div className={styles.innerColumn}>
                            <span className={styles.textBold}>
                              Please enter your license information and attach
                              copies.
                              <br />
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    {licenses.map((license, index) => {
                      return (
                        <div key={license.id} className={styles.licenseContainer}>
                          <div
                            className={classNames(styles.innerColumnContainer)}
                          >
                            <div className={classNames(styles.innerColumn)}>
                              <InputBox
                                label={"License Type"}
                                placeholder={"License Type"}
                                setValue={(e) =>
                                  handleChange(
                                    license,
                                    e.target.value,
                                    "licenseType"
                                  )
                                }
                                value={license.licenseType}
                                disabled={disabled}
                              />
                            </div>
                            <div className={classNames(styles.innerColumn)}>
                              <SelectBox
                                label={"State"}
                                onChange={(value) => {
                                  handleChange(license, value, "issuedBy");
                                }}
                                placeholder={"Select"}
                                options={states}
                                selected={license.issuedBy}
                                disabled={disabled}
                              />
                              {/* <InputBox
                            label={"State"}
                            placeholder={"Issued By"}
                            setValue={(e) =>
                              handleChange(license, e.target.value, "issuedBy")
                            }
                            value={license.issuedBy}
                            disabled={disabled}
                          /> */}
                            </div>
                            <div className={classNames(styles.innerColumn)}>
                              <InputBox
                                label={"License #"}
                                placeholder={"License #"}
                                setValue={(e) =>
                                  handleChange(
                                    license,
                                    e.target.value,
                                    "licenseNumber"
                                  )
                                }
                                value={license.licenseNumber}
                                disabled={disabled}
                              />
                            </div>
                            {/* <div className={classNames(styles.innerColumn)}>
                                <FormDatePicker
                                  label={"Issued On"}
                                  placeholder={"Issued On"}
                                  setDate={(value) => {
                                    handleChange(license, value, "issuedOn");
                                  }}
                                  dateString={license.issuedOn}
                                  dateFormat=DATE_FORMAT_PATTERN
                                  disabled={disabled}
                                />
                              </div> */}
                            <div className={classNames(styles.innerColumn)}>
                              <FormDatePicker
                                label={"Expiration Date"}
                                placeholder={"Expiration Date"}
                                setDate={(value) => {
                                  handleChange(license, value, "expiresOn");
                                }}
                                dateString={license.expiresOn}
                                dateFormat={DATE_FORMAT_PATTERN}
                                disabled={disabled}
                              />
                            </div>
                          </div>
                          <div className={styles.innerColumnContainer}>
                            <div className={styles.innerColumn}>
                              <div className={styles.upload}>
                                {!disabled && (
                                  <AddButton
                                    onClick={() => onUploadLicenses(index)}
                                    label={"Add Files"}
                                    className={classNames(
                                      styles.addFileIcon,
                                      styles.actionIcons
                                    )}
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                          <div
                            className={classNames(styles.innerColumnContainer)}
                          >
                            <div
                              className={classNames(
                                styles.innerColumn,
                                styles.actions
                              )}
                            >
                              {license.files && license.files.length > 0
                                ? license.files.map((f) => (
                                  <DashboardPassportFileEditorItem
                                    key={f.id}
                                    name={f.name}
                                    onView={() => {
                                      window.open(f.url, "_blank");
                                    }}
                                    onDelete={() => {
                                      license.files = license.files.filter(
                                        (a) => a.Id != f.Id
                                      );
                                      setLicenses([...licenses]);
                                    }}
                                    canDelete={!disabled}
                                  />
                                ))
                                : null}
                              {license.newFiles && license.newFiles.length > 0
                                ? Array.from(license.newFiles).map((f, index) => (
                                  <DashboardPassportFileEditorItem
                                    key={index}
                                    name={f.name}
                                    onView={() => {
                                      window.open(
                                        URL.createObjectURL(f),
                                        "_blank"
                                      );
                                    }}
                                    onDelete={() => {
                                      license.newFiles =
                                        removeFileFromFileList(
                                          license.newFiles,
                                          index
                                        );
                                      setLicenses([...licenses]);
                                    }}
                                    canDelete={!disabled}
                                  />
                                ))
                                : null}
                            </div>
                          </div>
                          <hr />
                        </div>
                      );
                    })}

                    <input
                      type="file"
                      accept=".docx, .pdf,.txt,.pptx,.xlsx,.jpg,.jpeg,.png"
                      multiple={true}
                      onChange={(e) => onLicenseFileChange(e)}
                      ref={licenseFileRef}
                      style={{ display: "none" }}
                    />

                    {licenses.length > 0 && !disabled ? (
                      <AddButton
                        onClick={onAddMoreLicense}
                        label={"Add Another License"}
                        className={classNames(
                          styles.addFileIcon,
                          styles.actionIcons
                        )}
                      />
                    ) : null}
                  </div>
                </>
              ) : null}
            </div>
          )}
          {(requirement.type.HasDocumentation) && (
            <>
              <div className={styles.uploadRow}>
                <p className={styles.paragraph}>Upload Documentation</p>
                {!disabled && (
                  <AddButton
                    label="Add File"
                    onClick={() => {
                      fileRef.current.click();
                    }}
                  />
                )}
                <input
                  type="file"
                  accept=".docx, .pdf,.txt,.pptx,.xlsx,.jpg,.jpeg,.png"
                  multiple={true}
                  onChange={(e) => onFileChange(e)}
                  ref={fileRef}
                  style={{ display: "none" }}
                />
              </div>
              <div className={styles.fileSetup}>
                {files.map((f) => (
                  <DashboardPassportFileEditorItem
                    key={f.id}
                    name={f.name}
                    onView={() => {
                      console.log("onView ", f);
                      window.open(f.url, "_blank");
                    }}
                    onDelete={() => {
                      console.log("onDelete ", f);
                      if (canDeleteFile()) {
                        const confirmation = window.confirm(
                          "Are you sure you want to delete this document?"
                        );
                        if (confirmation) {
                          setFiles((files) =>
                            files.filter((file) => file.id !== f.id)
                          );
                        }
                      }
                    }}
                    canDelete={!disabled && canDeleteFile()}
                  />
                ))}
                {Array.from(newFiles).map((f, index) => (
                  <DashboardPassportFileEditorItem
                    key={index}
                    name={f.name}
                    onView={() => {
                      console.log("onView ", f);
                      window.open(URL.createObjectURL(f), "_blank");
                    }}
                    onDelete={() => {
                      console.log("onDelete ", f);
                      setNewFiles((files) =>
                        files.filter((file) => file.id != f.id)
                      );
                    }}
                    canDelete={!disabled}
                  />
                ))}
              </div>
            </>
          )}

          {errors.length > 0 && (
            <ul>
              {errors.map((error) => {
                return error && <li key={error} className={styles.error}>{error}</li>;
              })}
            </ul>
          )}

          <Modal
            isOpen={autoApprovalAlert}
            onRequestClose={() => {
              setAutoApprovalAlert(false);
            }}
            className={classNames([])}
          >
            <div className={styles.warningTitle}>
              <FontAwesomeIcon icon={faWarning}></FontAwesomeIcon> By saving
              this requirement you acknowledge receipt of the information. This
              requirement will be automatically approved.
            </div>
            <div>Do you want to continue?</div>
            <div className={styles.warningButtons}>
              <Button
                text={"YES"}
                type={"submit"}
                className={styles.customButton}
                onClick={(ev) => {
                  onSave();
                }}
              />
              <Button
                text={"NO"}
                type={"cancel"}
                className={styles.customButton}
                onClick={() => {
                  setAutoApprovalAlert(false);
                }}
              />
            </div>
          </Modal>

          <Modal
            isOpen={resetConfirmOpen}
            onRequestClose={() => setResetConfirmOpen(false)}
            className={classNames([])}
          >
            <div className={styles.warningTitle}>
              <FontAwesomeIcon icon={faWarning} /> <b>Status Reset Confirmation</b>
            </div>

            <div style={{ marginTop: 8, marginBottom: 16, textAlign: "center" }}>
              This action will reset the status of this requirement from{" "}
              <b>{requirement?.status}</b> to <b>Submitted</b> and will need to be
              reviewed again.
            </div>

            <div className={styles.warningButtons} style={{ display: "flex", justifyContent: "center" }}>
              <Button
                text={"Continue"}
                type={"submit"}
                className={styles.customButton}
                onClick={() => {
                  setResetConfirmOpen(false);
                  // Continue the normal flow (may show Auto Approval modal next)
                  proceedAfterResetCheck();
                }}
              />
              <Button
                text={"Cancel"}
                type={"cancel"}
                className={styles.customButton}
                onClick={() => setResetConfirmOpen(false)}
              />
            </div>
          </Modal>

          {!disabled && (
            <Button
              className={styles.custom_button}
              onClick={handleSaveClick}
              text="SAVE"
            />
          )}
        </div>
        <div className={classNames(styles.borderRight, styles.column2)}></div>
        <div className={classNames(styles.column, styles.column3)}>
          <h3>Submission Status:</h3>
          <h3>{requirement.status}</h3>

          <hr>{/* Horizontal Rule */}</hr>
          <PassportMessageForm requirementType={requirement.createdByTypeContact} messages={messages} onSend={(text, selectedOption, repliedToMessage) => handleOnSend(text, selectedOption, repliedToMessage)}
            canMessageStudent={requirement.CanMessageStudent}
            canMessageEducation={requirement.CanMessageEducation}
            canMessageHealthcare={requirement.CanMessageHealthcare}
            canMessageReviewer={requirement.CanMessageReviewer}
          />
        </div>
      </div>
    </>
  );
}

PassportUserInputView.propTypes = {
  requirement: PropTypes.shape({
    requirementName: PropTypes.string,
    abbreviation: PropTypes.string,
    requiredBy: PropTypes.any,
    frequency: PropTypes.string,
    instructions: PropTypes.string,
    status: PropTypes.string,
    files: PropTypes.arrayOf({}),
    messages: PropTypes.any,
  }),
};
